import { StepTile } from '@tran-monorepo/interfaces';

export const HOME_TRANSFORMATION_FUND_STEPS: StepTile[] = [
    {
        step: 1,
        title: 'home.steps-to-transformation-project.steps.step1.title',
        description: 'home.steps-to-transformation-project.steps.step1.description',
        icon: 'element-show',
        links: [
            {
                label: 'home.steps-to-transformation-project.steps.step1.links.link1.label',
                ariaLabel: 'home.steps-to-transformation-project.steps.step1.links.link1.aria-label',
                url: 'home.steps-to-transformation-project.steps.step1.links.link1.url',
                isDownload: true
            },
            {
                label: 'home.steps-to-transformation-project.steps.step1.links.link2.label',
                ariaLabel: 'home.steps-to-transformation-project.steps.step1.links.link2.aria-label',
                url: 'home.steps-to-transformation-project.steps.step1.links.link2.url',
                isDownload: true
            }
        ]
    },
    {
        step: 2,
        title: 'home.steps-to-transformation-project.steps.step2.title',
        description: 'home.steps-to-transformation-project.steps.step2.description',
        icon: 'element-search'
    },
    {
        step: 3,
        title: 'home.steps-to-transformation-project.steps.step3.title',
        description: 'home.steps-to-transformation-project.steps.step3.description',
        icon: 'element-add-user'
    },
    {
        step: 4,
        title: 'home.steps-to-transformation-project.steps.step4.title',
        description: 'home.steps-to-transformation-project.steps.step4.description',
        icon: 'element-send',
        links: [
            {
                label: 'home.steps-to-transformation-project.steps.step4.links.link1.label',
                url: 'home.steps-to-transformation-project.steps.step4.links.link1.url'
            }
        ]
    },
    {
        step: 5,
        title: 'home.steps-to-transformation-project.steps.step5.title',
        description: 'home.steps-to-transformation-project.steps.step5.description',
        icon: 'element-busy'
    },
    {
        step: 6,
        title: 'home.steps-to-transformation-project.steps.step6.title',
        description: 'home.steps-to-transformation-project.steps.step6.description',
        icon: 'element-presentation'
    },
    {
        step: 7,
        title: 'home.steps-to-transformation-project.steps.step7.title',
        description: 'home.steps-to-transformation-project.steps.step7.description',
        icon: 'element-thumbs-up'
    },
    {
        step: 8,
        title: 'home.steps-to-transformation-project.steps.step8.title',
        description: 'home.steps-to-transformation-project.steps.step8.description',
        icon: 'element-rocket'
    },
    {
        step: 9,
        title: 'home.steps-to-transformation-project.steps.step9.title',
        description: 'home.steps-to-transformation-project.steps.step9.description',
        icon: 'element-chat'
    }
];

export const HOME_FURTHER_LINKS = [
    {
        label: 'home.further-links.links.link2.label',
        url: 'home.further-links.links.link2.url',
        ariaLabel: 'home.further-links.links.link2.aria-label',
        isExternal: false
    },
    {
        label: 'home.further-links.links.link3.label',
        url: 'home.further-links.links.link3.url',
        ariaLabel: 'home.further-links.links.link3.aria-label',
        isExternal: true
    },
    {
        label: 'home.further-links.links.link4.label',
        url: 'home.further-links.links.link4.url',
        ariaLabel: 'home.further-links.links.link4.aria-label',
        isExternal: true
    },
    {
        label: 'home.further-links.links.link5.label',
        url: 'home.further-links.links.link5.url',
        ariaLabel: 'home.further-links.links.link5.aria-label',
        isExternal: true
    }
];
